import React from 'react';

import './BonusWidget.scss';

function BonusWidget({ Adventure, Request }) {

  if (!Request || !Request.bonuses) return '';

  return (
    <div className="bonus-container">
      <div className="bonus-progress-bar">
        <div 
          className="bonus-progress" 
          style={{ width: `${(Request.person/Adventure.max * 100) || 1}%` }}
        >
          <span>{Request.person}</span>
        </div>
        <span className="bonus-marker-count count-min">0</span>
        <span className="bonus-marker-count count-max">{Adventure.max}</span>

        {/* <div 
          className="bonus-marker" 
          style={{ left: `${(Adventure.min || 1)/Adventure.max * 100}%` }} 
        /> */}
        <p 
          className="bonus-marker-title" 
          style={{ left: `${(Adventure.min || 1)/Adventure.max * 100}%`, top: '35px' }}
        >
          Mínimo
        </p>
        <span 
          className="bonus-marker-count" 
          style={{ left: `${(Adventure.min || 1)/Adventure.max * 100}%` }}
        >
          {Adventure.min || 1}
        </span>

        {Request.bonuses.map((bonus, index) => (
          <div key={`pk_request_bonus${bonus.pk_request_bonus}`}>
            <div 
              className="bonus-marker" 
              style={{ left: `${(bonus.minimal || 1)/Adventure.max * 100}%` }} 
            />
            <p 
              className="bonus-marker-title"
              style={{ left: `${(bonus.minimal || 1)/Adventure.max * 100}%` }} 
            >
              <span>{index + 1}º <br /> Bônus</span>
            </p>
            <span 
              className="bonus-marker-count"
              style={{ left: `${(bonus.minimal || 1)/Adventure.max * 100}%` }} 
            >
              {bonus.minimal}
            </span>
          </div>
        ))}
      </div>

      <ul className="bonus-goals">
        {Request.bonuses.sort((a,b) => a.minimal < b.minimal ? -1 : 1).map((bonus, index) => (
          <li key={`pk_request_bonus${bonus.pk_request_bonus}`}>
            <div className={`${Request.person >= bonus.minimal ? 'bonus-completed' : ''}`}>
              <span>{index + 1}º <br /> Bônus</span>
            </div>
            <p>{bonus.description}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BonusWidget;